export const downloaderConstants = {
    FETCH_FILE_LIST_REQUEST: "FETCH_FILE_LIST_REQUEST",
    FETCH_FILE_LIST_SUCCESS: "FETCH_FILE_LIST_SUCCESS",
    FETCH_FILE_LIST_FAILURE: "FETCH_FILE_LIST_FAILURE",

    GET_DOWNLOAD_REQUEST_REQUEST: "GET_DOWNLOAD_REQUEST_REQUEST",
    GET_DOWNLOAD_REQUEST_SUCCESS: "GET_DOWNLOAD_REQUEST_SUCCESS",
    GET_DOWNLOAD_REQUEST_FAILURE: "GET_DOWNLOAD_REQUEST_FAILURE",

    DELETE_PLATFORM_FILES_REQUEST: "DELETE_PLATFORM_FILES_REQUEST",
    DELETE_PLATFORM_FILES_SUCCESS: "DELETE_PLATFORM_FILES_SUCCESS",
    DELETE_PLATFORM_FILES_FAILURE: "DELETE_PLATFORM_FILES_FAILURE",

    DELETE_PLATFORM_FILE_REQUEST: "DELETE_PLATFORM_FILE_REQUEST",
    DELETE_PLATFORM_FILE_SUCCESS: "DELETE_PLATFORM_FILE_SUCCESS",
    DELETE_PLATFORM_FILE_FAILURE: "DELETE_PLATFORM_FILE_FAILURE",

    FETCH_PLATFORM_FILE_INTEGRATIONS_REQUEST: "FETCH_PLATFORM_FILE_INTEGRATIONS_REQUEST",
    FETCH_PLATFORM_FILE_INTEGRATIONS_SUCCESS: "FETCH_PLATFORM_FILE_INTEGRATIONS_SUCCESS",
    FETCH_PLATFORM_FILE_INTEGRATIONS_FAILURE: "FETCH_PLATFORM_FILE_INTEGRATIONS_FAILURE",

    FETCH_PLATFORM_FILE_ORGANIZATIONS_REQUEST: "FETCH_PLATFORM_FILE_ORGANIZATIONS_REQUEST",
    FETCH_PLATFORM_FILE_ORGANIZATIONS_SUCCESS: "FETCH_PLATFORM_FILE_ORGANIZATIONS_SUCCESS",
    FETCH_PLATFORM_FILE_ORGANIZATIONS_FAILURE: "FETCH_PLATFORM_FILE_ORGANIZATIONS_FAILURE",

    TOGGLE_DOWNLOAD_LINK_MODAL: "TOGGLE_DOWNLOAD_LINK_MODAL",
    SET_DOWNLOAD_LINK_MODAL_PROPERTIES: "SET_DOWNLOAD_LINK_MODAL_PROPERTIES",
    TOGGLE_DELETE_DOWNLOAD_MODAL: "TOGGLE_DELETE_DOWNLOAD_MODAL",
    CLEAR_DOWNLOAD_REQUEST: "CLEAR_DOWNLOAD_REQUEST",
};
